import CampusPage from './CampusPage';
import { CAMPUS_DATA } from '../../data/campus';

export default function MasCentro() {
  return <CampusPage campus={CAMPUS_DATA.centro} />;
}
